(function() {
  const swatchSelector = '[data-product-card-swatch]';
  const cardSelector = '[data-grid-item], [data-product-card]';

  class ProductCardSwatches extends HTMLElement {
    connectedCallback() {
      this.fieldset = this.querySelector('[data-sibling-fieldset]');
      this.count = this.querySelector('[data-sibling-count]');
      this.productInfo = this.closest('[data-product-information]');
      this.swatchesStyle = window.theme?.settings?.collectionSwatchStyle;

      if (!this.fieldset) return;

      if (['grid', 'slider', 'limited'].includes(this.swatchesStyle)) {
        this.fieldset.classList.add('is-visible');
      }

      if (this.count && this.productInfo && this.swatchesStyle === 'text-slider') {
        this.count.addEventListener('mouseenter', () => {
          this.fieldset.classList.add('is-visible');
        });

        this.productInfo.addEventListener('mouseleave', () => {
          this.fieldset.classList.remove('is-visible');
        });
      }
    }
  }

  if (!customElements.get('product-card-swatches')) {
    customElements.define('product-card-swatches', ProductCardSwatches);
  }

  function setLayerImage(layer, src, alt) {
    if (!layer) return;

    layer.classList.remove('is-visible');
    layer.replaceChildren();

    if (!src) return;

    const image = document.createElement('img');
    image.src = src;
    image.alt = alt || '';
    image.decoding = 'async';

    const showImage = () => {
      if (layer.contains(image) && image.naturalWidth > 0) {
        layer.classList.add('is-visible');
      }
    };
    image.addEventListener('load', showImage, {once: true});
    layer.append(image);

    if (image.complete) showImage();
  }

  function updatePrice(card, swatch) {
    if (swatch.dataset.productCardSwatchKind !== 'sibling') return;

    const priceElement = card.querySelector('[data-product-price]');
    const price = swatch.dataset.productCardPrice;
    const compareAtPrice = swatch.dataset.productCardCompareAtPrice;

    if (!priceElement || !price) return;

    const priceWrapper = document.createElement('span');
    priceWrapper.className = compareAtPrice ? 'price sale' : 'price';

    if (compareAtPrice) {
      const currentPrice = document.createElement('span');
      const oldPrice = document.createElement('span');
      currentPrice.className = 'new-price';
      oldPrice.className = 'old-price';
      currentPrice.textContent = price;
      oldPrice.textContent = compareAtPrice;
      priceWrapper.append(currentPrice, ' ', oldPrice);
    } else {
      priceWrapper.textContent = price;
    }

    priceElement.replaceChildren(priceWrapper);
  }

  function updateCutline(card, swatch) {
    if (swatch.dataset.productCardSwatchKind !== 'sibling') return;

    const cutline = card.querySelector('[data-product-cutline]');
    if (!cutline) return;

    const value = swatch.dataset.productCardCutline || '';
    const reserveSpace = cutline.dataset.anySiblingCutline === 'true';
    cutline.textContent = value || (reserveSpace ? '\u00a0' : '');
    cutline.title = value;
  }

  function renderSelectedQuickAddModal() {
    const params = new URLSearchParams({section_id: 'api-product-upsell'});
    const variantId = this.dataset.productCardQuickAddVariant;

    if (variantId) {
      params.set('variant', variantId);
    }

    window
      .fetch(`${window.theme.routes.root}products/${this.handle}?${params.toString()}`)
      .then(this.upsellErrorsHandler)
      .then((response) => response.text())
      .then((response) => this.modalCreate(response));
  }

  function updateQuickAdd(card, swatch) {
    const productId = swatch.dataset.productCardProductId;
    const productHandle = swatch.dataset.productCardProductHandle;
    const variantId = swatch.dataset.productCardVariantId;

    if (!productId || !productHandle) return;

    card.querySelectorAll('quick-add-product').forEach((quickAdd) => {
      const holder = quickAdd.querySelector('[data-quick-add-holder]');
      const modalButton = holder?.querySelector('[data-quick-add-modal-handle]');
      const variantInput = holder?.querySelector('input[name="id"]');
      const modalTemplate = holder?.querySelector('[data-quick-add-modal-template]');
      const modal = modalTemplate?.content.querySelector('[data-quick-add-modal]');

      quickAdd.handle = productHandle;
      quickAdd.productId = productId;
      quickAdd.dataset.productCardQuickAddVariant = variantId || '';

      holder?.setAttribute('data-quick-add-holder', productId);
      modalButton?.setAttribute('data-quick-add-modal-handle', productHandle);
      modal?.setAttribute('data-product-id', productId);

      if (variantInput && variantId) {
        variantInput.value = variantId;
      }

      if (modalButton) {
        quickAdd.renderModal = renderSelectedQuickAddModal;
      }
    });
  }

  function selectSwatch(swatch) {
    const card = swatch.closest(cardSelector);
    if (!card) return;

    card.querySelectorAll(swatchSelector).forEach((item) => {
      const selected = item === swatch;
      item.setAttribute('aria-pressed', String(selected));
      item.classList.toggle('swatch__link--current', selected && item.classList.contains('swatch__link'));
      item.classList.toggle('sibling__link--current', selected && item.classList.contains('sibling__link'));
    });

    const alt = swatch.getAttribute('aria-label') || '';
    setLayerImage(
      card.querySelector('.product-item__bg__swatch--primary'),
      swatch.dataset.productCardPrimaryImage,
      alt
    );
    setLayerImage(
      card.querySelector('.product-item__bg__swatch--secondary'),
      swatch.dataset.productCardSecondaryImage,
      alt
    );

    const url = swatch.dataset.productCardUrl;
    if (url) {
      card.querySelectorAll('a[data-product-link]').forEach((link) => {
        link.href = url;
      });
    }

    updatePrice(card, swatch);
    updateCutline(card, swatch);
    updateQuickAdd(card, swatch);
  }

  document.addEventListener(
    'click',
    (event) => {
      const swatch = event.target.closest(swatchSelector);
      if (!swatch) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      selectSwatch(swatch);
    },
    true
  );
})();

(function() {
  const availabilityFilter = 'filter.v.availability';
  const collectionPath = /\/collections\/[^/]+\/?$/;

  function updateCollectionLink(link) {
    const href = link.getAttribute('href');
    if (!href) return;

    let url;

    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return;
    }

    if (url.origin !== window.location.origin || !collectionPath.test(url.pathname)) return;
    if (url.searchParams.get(availabilityFilter) === '1') return;

    url.searchParams.set(availabilityFilter, '1');
    link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
  }

  function updateCollectionLinks(root) {
    if (root.matches?.('a[href]')) {
      updateCollectionLink(root);
    }

    root.querySelectorAll?.('a[href]').forEach(updateCollectionLink);
  }

  function initializeCollectionLinks() {
    updateCollectionLinks(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          updateCollectionLink(mutation.target);
          return;
        }

        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            updateCollectionLinks(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['href'],
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCollectionLinks, {once: true});
  } else {
    initializeCollectionLinks();
  }
})();
